import {
    THANALISTAGENTFORPARTNER_SUCCESS,
    THANALISTAGENTFORPARTNER_FAILED,
    RESET_THANALISTAGENTFORPARTNER,
    LOADING_THANALISTAGENTFORPARTNER,
    NETWORK_ERROR_THANALISTAGENTFORPARTNER
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetTHANALISTAGENTFORPARTNER = () => {
    return { type: RESET_THANALISTAGENTFORPARTNER };
};

const partnerThanaListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_THANALISTAGENTFORPARTNER });
    await partnerServices
        .post("thanaList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerThanaListReqsuccess(res.data));
                    break;
                default:
                    dispatch(partnerThanaListReqFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_THANALISTAGENTFORPARTNER,
                payload: err
            });
        });
};

function partnerThanaListReqsuccess(data) {
    return {
        type: THANALISTAGENTFORPARTNER_SUCCESS,
        payload: data,
    };
}

function partnerThanaListReqFailed(data) {
    return {
        type: THANALISTAGENTFORPARTNER_FAILED,
        payload: data,
    };
}

export { resetTHANALISTAGENTFORPARTNER, partnerThanaListReq }